import axios, { AxiosResponse } from 'axios'
import {
  AceiteTermoUsuario,
  AceiteTermoUsuarioDto,
  TermoConsentimento,
  TermosQueryResponse,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const TERMOS_URL = `${API_URL}/termos`

export const getTermos = (query: string): Promise<TermosQueryResponse> => {
  return axios
    .get(`${TERMOS_URL}?${query}`)
    .then((res: AxiosResponse<TermosQueryResponse>) => res.data)
}

export const createTermo = (termo: TermoConsentimento): Promise<TermoConsentimento> => {
  return axios
    .post(`${TERMOS_URL}`, termo)
    .then((res: AxiosResponse<TermoConsentimento>) => res.data)
}

export const getTermoById = (id: number): Promise<TermoConsentimento> => {
  return axios.get(`${TERMOS_URL}/${id}`).then((res: AxiosResponse<TermoConsentimento>) => res.data)
}

/*
 * Termo de ciência do usuário (LGPD). Com a ciência pendente o backend responde 403
 * `TERMO_CIENCIA_PENDENTE` em tudo, menos nestas duas rotas, no logout e na troca de senha.
 */

/** 404 quando não há termo de usuário publicado: nada a aceitar. */
export const getTermoUsuarioVigente = (): Promise<TermoConsentimento> => {
  return axios
    .get(`${TERMOS_URL}/usuario/vigente`)
    .then((res: AxiosResponse<TermoConsentimento>) => res.data)
}

export const aceitarTermoUsuario = (dto: AceiteTermoUsuarioDto): Promise<AceiteTermoUsuario> => {
  return axios
    .post(`${TERMOS_URL}/usuario/aceite`, dto)
    .then((res: AxiosResponse<AceiteTermoUsuario>) => res.data)
}
